import type { CanBuilder, DefineAbilityForUser } from "../types";
import type { GetApplicationApiResponse } from "@/services/schemas";

type ApplicationAttributeConditions = {
	eticistId: GetApplicationApiResponse["eticistId"];
};

type ApplicationEvaluateConditions = {
	status: GetApplicationApiResponse["status"];
	evaluation: GetApplicationApiResponse["evaluation"]["status"];
	eticistId: GetApplicationApiResponse["eticistId"];
};

type ApplicationEvaluateStatusConditions = Pick<
	ApplicationEvaluateConditions,
	"status" | "evaluation"
>;

export function defineEticiRules({
	can,
	user,
}: {
	can: CanBuilder;
	user: DefineAbilityForUser;
}): void {
	can(
		"attribute",
		"Application",
		({ eticistId }: ApplicationAttributeConditions) => !eticistId,
	);

	if (user.role === "admin") {
		can(
			"evaluate",
			"Application",
			({ status, evaluation }: ApplicationEvaluateStatusConditions) =>
				(status === "Em revisão" && evaluation === "Revisar") ||
				(status === "Em avaliação" && !evaluation),
		);
	} else {
		can(
			"evaluate",
			"Application",
			({ status, evaluation, eticistId }: ApplicationEvaluateConditions) =>
				((status === "Em revisão" && evaluation === "Revisar") ||
					(status === "Em avaliação" && !evaluation)) &&
				eticistId === user.id,
		);
	}
}
